<template>
  <component
    :is="variant"
    v-if="activeStep && data?.resolution && variant"
    :active-timeline-step="activeStep"
    :resolution="data.resolution"
  />
</template>

<script lang="ts" setup>
import { navigateTo, useRoute } from '#imports'

import { DASHBOARD as DASHBOARD_ROUTE } from '~/scopes/dashboard/routes'

import { CUSTOMER_CARE as CUSTOMER_CARE_ROUTES } from '../../../route-names'

import { useReturnConfirmationData } from './composables/useReturnConfirmationData'
import { useReturnConfirmationVariant } from './composables/useReturnConfirmationVariant'

const { params } = useRoute()

const { data, error } = await useReturnConfirmationData({
  resolutionId: params.resolutionId as string,
})

if (error.value) {
  await navigateTo({
    name: DASHBOARD_ROUTE.MY_ORDERS.SELF,
  })
}

const { activeStep, variant, variantError } = useReturnConfirmationVariant({
  orderlineTimeline: data.value?.orderlineTimeline,
  resolution: data.value?.resolution,
})

if (variantError) {
  await navigateTo({
    name: CUSTOMER_CARE_ROUTES.RESOLUTION.RESOLUTION_CONTACT_CONFIRMATION,
    params: {
      resolutionId: params.resolutionId as string,
    },
  })
}
</script>
